import React from 'react';
import { Box, Flex, Avatar } from '@chakra-ui/react';
import { Typography } from '../typography/typography';
import cardBackground from '../../../assets/photos/card_background.png';

export function TestimonialCard({ name, username, text, avatarSrc }) {
  return (
    <Box
      height={{ base: 'auto', md: '117px', lg: '117px' }}
      minHeight={{ base: '117px', md: '117px', lg: '117px' }}
      width="100%"
      pt={{ base: '16px', md: '24px', lg: '24px' }}
      pr={{ base: '16px', md: '16px', lg: '16px' }}
      pb={{ base: '16px', md: '24px', lg: '24px' }}
      pl={{ base: '16px', md: '16px', lg: '16px' }}
      borderRadius="16px"
      backgroundImage={`url(${cardBackground})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      boxShadow="inset 0 0 0 1px linear-gradient(116.62deg, rgba(222, 131, 65, 0.18) 30.33%, rgba(223, 153, 102, 0) 66.17%, rgba(224, 176, 141, 0) 100%)"
      flexShrink={0}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      gap={{ base: '8px', md: '12px', lg: '12px' }}
      isolation="isolate">
      <Flex alignItems="center">
        {avatarSrc && <Avatar size="sm" src={avatarSrc} name={name} mr={2} />}
        <Box>
          <Typography fontFamily="Playfair Display" fontSize="18px" fontWeight="500" lineHeight="130%" color="#E7DFCD">
            {name}
          </Typography>
          <Typography
            fontFamily="Manrope"
            fontSize="10px"
            fontWeight="500"
            lineHeight="130%"
            letterSpacing="0.05em"
            textTransform="uppercase"
            color="#FF335F">
            @{username}
          </Typography>
        </Box>
      </Flex>
      <Typography variant="body-small" color="#E5DCC7" mb={3}>
        {text}
      </Typography>
    </Box>
  );
}
